<template>
  <layout-no-padding>
    <transition name="fadeToggle" mode="out-in" v-if="!!bills">
      <v-flex>
        <v-card>
          <v-container fluid>
            <v-layout row wrap class="vertical-center-container">
              <multi-actions page="bills" v-if="userAuthClass" :selectedCount="selectedCount"></multi-actions>
              <v-spacer></v-spacer>
              <v-flex xs12 sm2 md4 class="text-xs-right">
                <v-tooltip bottom v-if="selected.length > 0">
                  <v-btn flat color="grey" icon @click="selected = [];" slot="activator">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  <span>Deselect All</span>
                </v-tooltip>
                <v-menu
                  bottom
                  left
                  transition="scale-transition"
                  max-height="600px"
                  origin="top right"
                  :close-on-content-click="false"
                  v-model="fieldChooserMenu"
                >
                  <v-btn flat icon color="grey" slot="activator">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                      <v-list-tile-action>
                        <v-checkbox
                          :color="$store.state.global.pages[$route.name].color"
                          v-model="defaultHeaders"
                          :label="header.text"
                          :value="header.value"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>

              <!-- SELECT ALL TRIPS ALERT -->
              <v-alert
                v-if="selected.length >= 10"
                :value="true"
                color="grey lighten-3"
                icon="notification_important"
                style="width: 100%; border-radius: 4px;"
                class="grey--text text--darken-2 py-1"
              >
                <div class="flex-container-center">
                  <span>{{selected.length}} items are selected.</span>
                  <v-btn
                    v-if="selected.length == filteredBills.length"
                    @click="selected = []; selectedAll = false"
                    flat
                    color="grey"
                  >Unselect all {{$vuetify.breakpoint.smAndUp ? `${selected.length} items` : ''}}</v-btn>
                  <v-btn
                    v-else
                    @click="selected = filteredBills; selectedAll = true"
                    flat
                    :color="$store.state.global.pages.billing.color"
                  >Select all {{$vuetify.breakpoint.smAndUp ? `${filteredBills.length} items` : ''}}</v-btn>
                </div>
              </v-alert>
            </v-layout>
          </v-container>

          <v-data-table
            :items="dateFilteredBills"
            :headers="headers"
            :rows-per-page-items="itemsPerPageOptions"
            v-model="selected"
            select-all
            :search="!filterCol ? filterBy : ''"
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <div class="text-xs-center grey--text subheading">No Bills for the selected criteria.</div>
            </template>
            <template slot="items" slot-scope="props">
              <bill-row
                :bill="props.item"
                :value="props.selected"
                :headers="headers"
                @input="toggleSelected"
                :key="props.item.id"
              ></bill-row>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </transition>
  </layout-no-padding>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import BillService from '@/services/requests/billService'
import BillRow from '@/components/bills/billRow'
import MultiActions from '@/components/trips/actions/multiTripActions'
import BillHeaders from '@/components/bills/billHeaders'
import HeaderFilters from '@/services/mixins/headerFilters'
import { format } from 'date-fns'

export default {
  mixins: [BillHeaders, HeaderFilters],
  data() {
    return {
      color: 'blue',
      searchTerm: '',
      loading: false,
      fieldChooserMenu: false
    }
  },
  methods: {
    //ADDS OR REMOVES OBJECTS FROM THE SELECTED ARRAY, DEPENDING ON WHETHER TRUE OR FALSE WAS EMMITED FROM TRIPROW COMPONENT
    toggleSelected(val) {
      if (val.value) {
        this.selected.push(val.object)
      } else {
        var index = this.selected.indexOf(val.object)
        this.selected.splice(index, 1)
      }
    },

    // sumCol(array, prop) {
    //     return array.reduce((total, item) => {
    //         if(!!item[prop]) {
    //             return total + Number(item[prop])
    //         }
    //         return total;
    //     }, 0)
    // },
    // getBillTotals(array) {
    //     var tempArray = array;
    //     for (var bill of tempArray) {
    //         bill.total = this.sumCol(bill.billLines, 'costTotal')
    //         bill.siteWeightTotal = this.sumCol(bill.billLines, 'siteWeightTotal')
    //         bill.tipWeightTotal = this.sumCol(bill.billLines, 'tipWeightTotal')
    //         bill.scaleWeightTotal = this.sumCol(bill.billLines, 'scaleWeightTotal')
    //         bill.hoursTotal = this.sumCol(bill.billLines, 'hoursTotal')
    //     }
    //     return tempArray;
    // },

    getBills() {
      if (!!this.$route.query.ids && this.showCreated) {
        var ids = JSON.parse(this.$route.query.ids)
        this.getBillsBy({ ids: ids })
      } else {
        this.showingCreated = false
        this.getBillsByBillingPeriod()
      }
    },
    getBillsBy(payload) {
      //console.log('getting created bills!');
      this.loading = true
      BillService.getBills(payload)
        .then(result => {
          //console.log('GOT THEM!');
          if (!!payload.ids)
            result.data.result.forEach(bill => {
              bill.new = true
            })
          this.bills = result.data.result
          this.loading = false
        })
        .catch(err => {
          this.snackError()
          this.loading = false
        })
    },
    getBillsByBillingPeriod() {
      // if (!this.billingPeriod) this.billingPeriod = format(new Date(), 'YYYY-MM')
      this.loading = true
      BillService.getBillsByBillingPeriod(this.billingPeriod)
        .then(result => {
          //console.log(result.data);
          //this.bills = this.getBillTotals(result.data.result);
          this.bills = result.data.result
          //console.log(this.bills);
          this.loading = false
        })
        .catch(err => {
          this.snackError()
          console.log(err)
          this.loading = false
        })
    },
    getConfirmedBills() {
      this.loading = true
      BillService.getConfirmedBills()
        .then(result => {
          //console.log(result.data);
          this.bills = result.data.result
          this.loading = false
        })
        .catch(err => {
          this.snackError()
          console.log(err)
          this.loading = false
        })
    }
  },
  computed: {
    bills: Store.getSet({ store: 'bills', prop: 'bills' }),
    filterBy: Store.getSet({ store: 'bills', prop: 'filterBy' }),
    filterCol: Store.getSet({ store: 'bills', prop: 'filterCol' }),
    dates: Store.getSet({ store: 'bills', prop: 'dates' }),
    selected: Store.getSet({ store: 'bills', prop: 'selected' }),
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    showCreated: Store.getSet({ store: 'shared', prop: 'showCreated' }),
    selectedAll: Store.getSet({ store: 'bills', prop: 'selectedAll' }),
    selectedCount() {
      return this.selected.length
    },
    headers() {
      var actions = {
        text: 'Actions',
        align: 'center',
        value: '',
        sortable: false,
        colData: '',
        type: 'action'
      }

      var tempArray = this.filterHeaders()
      tempArray.push(actions)
      return tempArray
    },
    filteredBills() {
      if (!this.filterCol || !this.filterBy) {
        return this.bills
      }
      return this.bills.filter(bill => {
        if (this.getObjectPath(this.filterCol, bill) != null) {
          return (
            this.getObjectPath(this.filterCol, bill)
              .toString()
              .toLowerCase()
              .indexOf(this.filterBy.toString().toLowerCase()) > -1
          )
        }
      })
    },
    dateFilteredBills() {
      //console.log('dateFilter triggered');
      if (!!this.dates.length) {
        //console.log('dates has length')
        return this.filteredBills.filter(bill => {
          ////console.log(bill.docket);
          return true
          //return bill.docket.date >= this.dates[0] && bill.docket.date <= this.dates[1]
        })
      } else {
        return this.filteredBills
      }
    }
  },
  mounted() {
    if (!!this.$route.query.ids) {
      this.showCreated = true
    } else {
      this.showCreated = false
    }
    this.getBills()
  },
  beforeDestroy() {
    this.bills = []
    this.selected = []
  },
  components: {
    BillRow,
    MultiActions
  },
  props: {
    page: String
  },
  watch: {
    billingPeriod(val) {
      this.getBills()
    },
    showCreated(val) {
      this.getBills()
    }
  }
}
</script>

<style>
</style>
